import Divider from 'components/shared/Divider/Divider';

import AddressSection from './AddressSection';
import AvailabilityForm from './AvailabilityForm';
import ClearingHouseSection from './ClearingHouseSection';
import PersonalInformationSection from './PersonalInformationSection';
import StaffStatesSection from './StaffStatesSection';
import StaffStatus from './StaffStatus';

const StaffForm = ({ formik, practiceId, staffMemberId }) => {
  return (
    <div className="flex flex-col gap-6">
      <PersonalInformationSection formik={formik} practiceId={practiceId} />
      <Divider />
      <AddressSection formik={formik} />
      {staffMemberId && (
        <>
          <Divider />
          <AvailabilityForm values={formik.values} setFieldValue={formik.setFieldValue} />
          <Divider />
          <StaffStatesSection formik={formik} />
        </>
      )}
      <Divider />
      <ClearingHouseSection formik={formik} />
      <Divider />
      <StaffStatus formik={formik} />
    </div>
  );
};

export default StaffForm;
